import { STORAGE_KEYS } from '../constants/storage-keys';
import { saveData } from './entry-save-service';
import { saveActiveFastingToSupabase } from './active-fasting-service';

export const migrateDataToUser = async (userId: string): Promise<void> => {
  try {
    const keys = Object.values(STORAGE_KEYS);
    
    for (const key of keys) {
      const data = localStorage.getItem(key);
      if (!data) continue;
      
      const parsedData = JSON.parse(data);
      
      if (Array.isArray(parsedData)) {
        const updatedData = parsedData.map(item => ({
          ...item,
          userId
        }));
        
        await saveData(key, updatedData);
      } else if (key === STORAGE_KEYS.ACTIVE_FASTING && parsedData) {
        await saveActiveFastingToSupabase(parsedData, userId);
      }
    }
    
    console.log('Data migration complete!');
  } catch (error) {
    console.error('Error migrating data:', error);
  }
};
